
  <div data-testid="order-preempt-page" class="main-content p-4 flex-table-page">
    <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
      Pre-emption management
    </h2>
    <!-- Search Form -->
    <app-search-form
      data-testid="order-preempt-search-form"
      [orderSources]="channels"
      [salesChannels]="stores"
      [buyerNotesOptions]="preemptStatuses"
      [giftOptions]="[]"
      (formSearch)="onSearch($event)"
      (formReset)="onReset()"
    ></app-search-form>

    <!-- Data Table -->
    <div class="flex-table-section">
      <app-data-table
        data-testid="order-preempt-table"
        [dataSource]="orders"
        [columns]="columns"
        [rows]="rows"
        [first]="first"
        [totalRecords]="totalRecords"
        [loading]="loading"
        scrollHeight="flex"
        (pageChange)="onPageChange($event)">
      </app-data-table>
    </div>
  </div>
